<template>
  <div class="animated fadeIn">
    <div v-if="mData.viewMode == 'create'">
      <hssk-bn></hssk-bn>
    </div>
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} đối tượng theo dõi</span>
        <span v-if="mData.viewMode == 'update'">{{aLang.c_update}} đối tượng theo dõi</span>
        <span v-if="mData.viewMode == 'detail'">{{aLang.c_detail}} đối tượng theo dõi</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="2">
              <el-form-item label="Loại tiếp xúc" prop="loai_tiep_xuc">
                <el-select
                  v-model="mData.dataForm.loai_tiep_xuc"
                  :placeholder="aLang.c_select"
                  filterable
                  clearable
                  :disabled="mData.viewMode == 'detail'"
                >
                  <el-option
                    v-for="item in mData.dataDefault.loaiTiepXuc"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="2">
              <el-form-item label="Loại đối tượng" prop="loai_dt">
                <el-select
                  v-model="mData.dataForm.loai_dt"
                  :placeholder="aLang.c_select"
                  filterable
                  clearable
                  :disabled="mData.viewMode == 'detail'"
                >
                  <el-option
                    v-for="item in mData.dataDefault.loaiDoiTuong"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Ngày bắt đầu theo dõi" prop="ngay_theo_doi">
                <el-date-picker
                  type="datetime"
                  :format="aElement.datepicker.formatDatetime"
                  :valueFormat="aElement.datepicker.valueFormat"
                  v-model="mData.dataForm.ngay_theo_doi"
                  :placeholder="aElement.datepicker.placeholderDatetime"
                  clearable
                  :disabled="mData.viewMode == 'detail'"
                  @change="handleDoiTuong_chuyenTimeStart"
                ></el-date-picker>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Ngày kết thúc theo dõi" prop="ngay_ket_thuc_theo_doi">
                <el-date-picker
                  type="datetime"
                  :format="aElement.datepicker.formatDatetime"
                  :valueFormat="aElement.datepicker.valueFormat"
                  v-model="mData.dataForm.ngay_ket_thuc_theo_doi"
                  :placeholder="aElement.datepicker.placeholderDatetime"
                  clearable
                  :disabled="mData.viewMode == 'detail'"
                  @change="handleDoiTuong_chuyenTimeEnd"
                ></el-date-picker>
              </el-form-item>
            </b-col>

            <b-col md="2">
              <el-form-item label prop="tu_khai" class="noLabel">
                <el-checkbox v-model="mData.dataForm.tu_khai" :disabled="true">Tự khai báo</el-checkbox>
              </el-form-item>
            </b-col>
          </b-row>
          <b-tabs card pills vertical v-model="mData.tab.index[1]" nav-wrapper-class="w-200">
            <b-tab>
              <template slot="title">Đối tượng theo dõi</template>
              <div>
                <b-row>
                  <b-col md="3">
                    <el-form-item label="Mã thẻ" prop="doi_tuong.card_code">
                      <el-input
                        v-model="mData.dataForm.doi_tuong.card_code"
                        clearable
                        :disabled="mData.viewMode == 'detail'"
                      ></el-input>
                    </el-form-item>
                  </b-col>

                  <b-col md="3">
                    <el-form-item label="Họ tên" prop="doi_tuong.ten">
                      <el-input
                        v-model="mData.dataForm.doi_tuong.ten"
                        clearable
                        :disabled="mData.viewMode == 'detail'"
                      ></el-input>
                    </el-form-item>
                  </b-col>

                  <b-col md="3">
                    <el-form-item label="Giới tính" prop="doi_tuong.gioi_tinh">
                      <el-select
                        v-model="mData.dataForm.doi_tuong.gioi_tinh"
                        :placeholder="aLang.c_select"
                        filterable
                        clearable
                        :disabled="mData.viewMode == 'detail'"
                      >
                        <el-option
                          v-for="item in mData.dataDefault.dmGioiTinh"
                          :key="item.id"
                          :label="item.text"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>

                  <b-col md="3">
                    <el-form-item label="Ngày sinh" prop="doi_tuong.ngay_sinh">
                      <el-date-picker
                        type="date"
                        :format="aElement.datepicker.formatDate"
                        :valueFormat="aElement.datepicker.valueFormat"
                        v-model="mData.dataForm.doi_tuong.ngay_sinh"
                        :placeholder="aElement.datepicker.placeholderDate"
                        clearable
                        :disabled="mData.viewMode == 'detail'"
                      ></el-date-picker>
                    </el-form-item>
                  </b-col>

                  <b-col md="3">
                    <el-form-item label="Số điện thoại" prop="doi_tuong.so_dien_thoai">
                      <el-input
                        v-model="mData.dataForm.doi_tuong.so_dien_thoai"
                        clearable
                        :disabled="mData.viewMode == 'detail'"
                      ></el-input>
                    </el-form-item>
                  </b-col>

                  <b-col md="3">
                    <el-form-item label="Số CMND/CCCD" prop="doi_tuong.cmt">
                      <el-input
                        v-model="mData.dataForm.doi_tuong.cmt"
                        clearable
                        :disabled="mData.viewMode == 'detail'"
                      ></el-input>
                    </el-form-item>
                  </b-col>

                  <b-col md="3">
                    <el-form-item label="Quốc tịch" prop="doi_tuong.ma_quoc_tich">
                      <el-select
                        v-model="mData.dataForm.doi_tuong.ma_quoc_tich"
                        :placeholder="aLang.c_select"
                        filterable
                        clearable
                        :disabled="mData.viewMode == 'detail'"
                      >
                        <el-option
                          v-for="item in mData.dataDefault.dmQuocGia"
                          :key="item.MA_QGIA"
                          :label="item.ten_qg"
                          :value="item.MA_QGIA"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="3">
                    <el-form-item label="Tỉnh/TP" prop="doi_tuong.ma_tinh">
                      <el-select
                        v-model="mData.dataForm.doi_tuong.ma_tinh"
                        :placeholder="aLang.c_select"
                        filterable
                        clearable
                        :disabled="mData.viewMode == 'detail'"
                        @change="fn_changeTinh(mData.dataForm.doi_tuong.ma_tinh, true)"
                      >
                        <el-option
                          v-for="item in mData.dataDefault.dmTinh"
                          :key="item.MA_TINH"
                          :label="item.TEN_TINH"
                          :value="item.MA_TINH"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Quận/Huyện" prop="doi_tuong.ma_huyen">
                      <el-select
                        v-model="mData.dataForm.doi_tuong.ma_huyen"
                        :placeholder="aLang.c_select"
                        filterable
                        clearable
                        :disabled="mData.viewMode == 'detail'"
                        @change="fn_changeHuyen(mData.dataForm.doi_tuong.ma_tinh, mData.dataForm.doi_tuong.ma_huyen, true)"
                      >
                        <el-option
                          v-for="item in mData.dataDefault.dmHuyen"
                          :key="item.MA_QUAN"
                          :label="item.TEN_QUAN"
                          :value="item.MA_QUAN"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Phường/Xã" prop="doi_tuong.ma_xa">
                      <el-select
                        v-model="mData.dataForm.doi_tuong.ma_xa"
                        :placeholder="aLang.c_select"
                        filterable
                        clearable
                        :disabled="mData.viewMode == 'detail'"
                      >
                        <el-option
                          v-for="item in mData.dataDefault.dmXa"
                          :key="item.MA_XA"
                          :label="item.TEN_XA"
                          :value="item.MA_XA"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="6">
                    <el-form-item
                      label="Thời gian nhập cảnh/ tiếp xúc lần cuối với ng nhiễm covid"
                      prop="doi_tuong.thoi_gian_nhap_canh_tiep_xuc_cuoi"
                    >
                      <el-date-picker
                        type="date"
                        :format="aElement.datepicker.formatDate"
                        :valueFormat="aElement.datepicker.valueFormat"
                        v-model="mData.dataForm.doi_tuong.thoi_gian_nhap_canh_tiep_xuc_cuoi"
                        :placeholder="aElement.datepicker.placeholderDate"
                        clearable
                        :picker-options="mData.pickerOptions"
                        :disabled="mData.viewMode == 'detail'"
                      ></el-date-picker>
                    </el-form-item>
                  </b-col>
                  <b-col md="12">
                    <el-form-item label="Địa chỉ lưu trú" prop="doi_tuong.dia_chi_luu_tru">
                      <el-input
                        v-model="mData.dataForm.doi_tuong.dia_chi_luu_tru"
                        clearable
                        :disabled="mData.viewMode == 'detail'"
                      ></el-input>
                    </el-form-item>
                  </b-col>
                </b-row>
              </div>
            </b-tab>
            <b-tab>
              <template slot="title">Thông tin chủ hộ</template>
              <b-row>
                <b-col md="2">
                  <el-form-item label prop="la_chu_ho" class="noLabel">
                    <el-checkbox
                      v-model="mData.dataForm.la_chu_ho"
                      :disabled="mData.viewMode == 'detail'"
                      @change="fn_test(mData.dataForm.la_chu_ho)"
                    >Là chủ hộ</el-checkbox>
                  </el-form-item>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="3">
                  <el-form-item label="Mã thẻ" prop="thong_tin_chu_ho.card_code">
                    <el-input
                      v-model="mData.dataForm.thong_tin_chu_ho.card_code"
                      clearable
                      :disabled="mData.viewMode == 'detail'"
                    ></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="3">
                  <el-form-item label="Họ tên" prop="thong_tin_chu_ho.ten">
                    <el-input
                      v-model="mData.dataForm.thong_tin_chu_ho.ten"
                      clearable
                      :disabled="mData.viewMode == 'detail'"
                    ></el-input>
                  </el-form-item>
                </b-col>

                <b-col md="3">
                  <el-form-item label="Giới tính" prop="thong_tin_chu_ho.gioi_tinh">
                    <el-select
                      v-model="mData.dataForm.thong_tin_chu_ho.gioi_tinh"
                      :placeholder="aLang.c_select"
                      filterable
                      clearable
                      :disabled="mData.viewMode == 'detail'"
                    >
                      <el-option
                        v-for="item in mData.dataDefault.dmGioiTinh"
                        :key="item.id"
                        :label="item.text"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>

                <b-col md="3">
                  <el-form-item label="Ngày sinh" prop="thong_tin_chu_ho.ngay_sinh">
                    <el-date-picker
                      type="date"
                      :format="aElement.datepicker.formatDate"
                      :valueFormat="aElement.datepicker.valueFormat"
                      v-model="mData.dataForm.thong_tin_chu_ho.ngay_sinh"
                      :placeholder="aElement.datepicker.placeholderDate"
                      clearable
                      :disabled="mData.viewMode == 'detail'"
                    ></el-date-picker>
                  </el-form-item>
                </b-col>

                <b-col md="3">
                  <el-form-item label="Số điện thoại" prop="thong_tin_chu_ho.so_dien_thoai">
                    <el-input
                      v-model="mData.dataForm.thong_tin_chu_ho.so_dien_thoai"
                      clearable
                      :disabled="mData.viewMode == 'detail'"
                    ></el-input>
                  </el-form-item>
                </b-col>

                <b-col md="3">
                  <el-form-item label="Số CMND/CCCD" prop="thong_tin_chu_ho.cmt">
                    <el-input
                      v-model="mData.dataForm.thong_tin_chu_ho.cmt"
                      clearable
                      :disabled="mData.viewMode == 'detail'"
                    ></el-input>
                  </el-form-item>
                </b-col>

                <b-col md="3">
                  <el-form-item label="Quốc tịch" prop="thong_tin_chu_ho.ma_quoc_tich">
                    <el-select
                      v-model="mData.dataForm.thong_tin_chu_ho.ma_quoc_tich"
                      :placeholder="aLang.c_select"
                      filterable
                      clearable
                      :disabled="mData.viewMode == 'detail'"
                    >
                      <el-option
                        v-for="item in mData.dataDefault.dmQuocGia"
                        :key="item.MA_QGIA"
                        :label="item.ten_qg"
                        :value="item.MA_QGIA"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
              </b-row>
            </b-tab>
            <!-- <b-tab>
              <template slot="title">Cán bộ theo dõi</template>
              <b-row>
                <b-col md="3">
                  <el-form-item label="Họ tên cán bộ theo dõi" prop="cb_theo_doi.name">
                    <el-input
                      v-model="mData.dataForm.cb_theo_doi.ho_ten"
                      clearable
                      :disabled="mData.viewMode == 'detail'"
                    ></el-input>
                  </el-form-item>
                </b-col>
              </b-row>
            </b-tab>-->
            <b-tab>
              <template slot="title">Cơ sở cách ly</template>
              <b-row>
                <b-col md="12">
                  <el-form-item label="Hình thức cách ly">
                    <el-radio-group
                      v-model="mData.dataForm.loai_cach_ly"
                      @change="fn_changeHinhThucCachLy(mData.dataForm.loai_cach_ly)"
                      :disabled="mData.viewMode == 'detail'"
                    >
                      <el-radio label="O_NHA" border>Cách ly tại nhà</el-radio>
                      <el-radio label="CSCL" border>Cách ly tại cơ sở cách ly</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </b-col>
              </b-row>
              <b-row v-if="mData.dataForm.loai_cach_ly == 'O_NHA'">
                <b-col md="12">
                  <el-form-item label="Địa chỉ chi tiết" prop="co_so_cach_ly.dia_chi">
                    <el-input
                      v-model="mData.dataForm.co_so_cach_ly.dia_chi"
                      clearable
                      :disabled="mData.viewMode == 'detail'"
                    ></el-input>
                  </el-form-item>
                </b-col>
              </b-row>
              <b-row v-if="mData.dataForm.loai_cach_ly == 'CSCL'">
                <b-col md="3">
                  <el-form-item label="Tỉnh/TP:" prop="co_so_cach_ly.ma_tinh">
                    <el-select
                      v-model="mData.dataForm.co_so_cach_ly.ma_tinh"
                      :placeholder="aLang.c_select"
                      filterable
                      clearable
                      :disabled="mData.viewMode == 'detail'"
                      @change="fn_changeTinh_cscl(mData.dataForm.co_so_cach_ly.ma_tinh, true)"
                    >
                      <el-option
                        v-for="item in mData.dataDefault.dmTinh_cscl"
                        :key="item.MA_TINH"
                        :label="item.TEN_TINH"
                        :value="item.MA_TINH"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>

                <b-col md="3">
                  <el-form-item label="Quận/Huyện:" prop="co_so_cach_ly.ma_huyen">
                    <el-select
                      v-model="mData.dataForm.co_so_cach_ly.ma_huyen"
                      :placeholder="aLang.c_select"
                      filterable
                      clearable
                      :disabled="mData.viewMode == 'detail'"
                      @change="fn_changeHuyen_cscl(mData.dataForm.co_so_cach_ly.ma_tinh, mData.dataForm.co_so_cach_ly.ma_huyen, true)"
                    >
                      <el-option
                        v-for="item in mData.dataDefault.dmHuyen_cscl"
                        :key="item.MA_QUAN"
                        :label="item.TEN_QUAN"
                        :value="item.MA_QUAN"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>

                <b-col md="3">
                  <el-form-item label="Xã/Phường:" prop="co_so_cach_ly.ma_xa">
                    <el-select
                      v-model="mData.dataForm.co_so_cach_ly.ma_xa"
                      :placeholder="aLang.c_select"
                      filterable
                      clearable
                      :disabled="mData.viewMode == 'detail'"
                    >
                      <el-option
                        v-for="item in mData.dataDefault.dmXa_cscl"
                        :key="item.MA_XA"
                        :label="item.TEN_XA"
                        :value="item.MA_XA"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col md="3">
                  <el-form-item label="Cơ sở cách ly" prop="co_so_cach_ly.ma_co_so">
                    <el-select
                      v-model="mData.dataForm.co_so_cach_ly.ma_co_so"
                      :placeholder="aLang.c_select"
                      filterable
                      clearable
                      :disabled="mData.viewMode == 'detail'"
                    >
                      <el-option
                        v-for="item in mData.dataDefault.dmCoSo"
                        :key="item.madiadiem"
                        :label="item.tendiadiem"
                        :value="item.madiadiem"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col md="6">
                  <el-form-item label="Họ tên cán bộ theo dõi" prop="cb_theo_doi.name">
                    <el-input
                      v-model="mData.dataForm.cb_theo_doi.ho_ten"
                      clearable
                      :disabled="mData.viewMode == 'detail'"
                    ></el-input>
                  </el-form-item>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab>
              <template slot="title">Người liên quan</template>
              <div>
                <b-row class="mb-2">
                  <b-col md="8"></b-col>
                  <b-col md="4" class="text-right">
                    <el-button
                      @click="fn_openModalNguoiLienQuan('create')"
                      type="info"
                      plain
                    >Thêm người liên quan</el-button>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="12">
                    <el-table
                      :data="mData.dataForm.nguoi_lien_quan"
                      border
                      max-height="400"
                      style="width: 100%; display: grid;"
                    >
                      <el-table-column prop label="STT" align="center" width="50">
                        <template slot-scope="scope">
                          <span>{{scope.$index + 1}}</span>
                        </template>
                      </el-table-column>

                      <el-table-column prop="ho_ten" label="Họ và tên" min-width="150" width="auto"></el-table-column>
                      <el-table-column
                        prop="gioi_tinh"
                        label="Giới tính"
                        min-width="100"
                        width="auto"
                        :formatter="fn_mapName_gioiTinh"
                      ></el-table-column>
                      <el-table-column
                        prop="noi_tiep_xuc"
                        label="Nơi tiếp xúc"
                        min-width="100"
                        width="auto"
                      ></el-table-column>
                      <!-- <el-table-column
                        prop="dia_chi_nguoi_tiep_xuc"
                        label="Địa chỉ người tiếp xúc"
                        min-width="100"
                        width="auto"
                      ></el-table-column>-->
                      <el-table-column
                        prop="sodt_nguoi_tiep_xuc"
                        label="SĐT người tiếp xúc"
                        min-width="100"
                        width="auto"
                      ></el-table-column>
                      <el-table-column
                        prop="cmt_nguoi_tiep_xuc"
                        label="CMND người tiếp xúc"
                        min-width="100"
                        width="auto"
                      ></el-table-column>
                      <!-- <el-table-column prop="khac" label="Khác" min-width="100" width="auto"></el-table-column> -->
                      <el-table-column :label="aLang.c_action" align="center" width="150">
                        <template slot-scope="scope">
                          <el-button
                            size="mini"
                            @click="fn_openModalNguoiLienQuan('detail',scope.$index)"
                            v-b-popover.hover.left="aLang.c_detail"
                          >
                            <i class="fa fa-eye"></i>
                          </el-button>
                          <el-button
                            size="mini"
                            @click="fn_openModalNguoiLienQuan('update', scope.$index)"
                            v-b-popover.hover.left="aLang.c_update"
                          >
                            <i class="icon-pencil icons"></i>
                          </el-button>
                          <el-button
                            size="mini"
                            @click="fn_openModalNguoiLienQuan('delete',scope.$index)"
                            v-b-popover.hover.left="aLang.c_delete"
                          >
                            <i class="icon-trash icons"></i>
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </b-col>
                </b-row>
              </div>
            </b-tab>
            <b-tab>
              <template slot="title">Lịch sử di chuyển</template>
              <div>
                <b-row class="mb-2">
                  <b-col md="8"></b-col>
                  <b-col md="4" class="text-right">
                    <el-button
                      @click="fn_openModal_lichSuDiChuyen('create')"
                      type="info"
                      plain
                    >Thêm lịch sử di chuyển</el-button>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="12">
                    <el-table
                      :data="mData.dataForm.lich_su_di_chuyen"
                      border
                      max-height="400"
                      style="width: 100%; display: grid;"
                    >
                      <el-table-column prop label="STT" align="center" width="50">
                        <template slot-scope="scope">
                          <span>{{scope.$index + 1}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="thoi_gian_tiep_xuc.bat_dau"
                        label="Thời gian bắt đầu"
                        min-width="140"
                        width="auto"
                        align="center"
                        :formatter="fn_formatterDatetime"
                      ></el-table-column>
                      <el-table-column
                        prop="thoi_gian_tiep_xuc.ket_thuc"
                        label="Thời gian kết thúc"
                        min-width="140"
                        width="auto"
                        align="center"
                        :formatter="fn_formatterDatetime"
                      ></el-table-column>

                      <el-table-column
                        prop="ho_ten"
                        label="Họ tên người tiếp xúc"
                        min-width="150"
                        width="auto"
                      ></el-table-column>
                      <el-table-column
                        prop="gioi_tinh"
                        label="Giới tính"
                        min-width="100"
                        width="auto"
                        :formatter="fn_mapName_gioiTinh"
                      ></el-table-column>
                      <el-table-column
                        prop="nam_sinh"
                        label="Năm sinh"
                        min-width="100"
                        width="auto"
                      ></el-table-column>
                      <!-- <el-table-column
                        prop="sodt_nguoi_tiep_xuc"
                        label="SĐT"
                        min-width="100"
                        width="auto"
                      ></el-table-column>-->
                      <el-table-column :label="aLang.c_action" align="center" width="150">
                        <template slot-scope="scope">
                          <el-button
                            size="mini"
                            @click="fn_openModal_lichSuDiChuyen('detail',scope.$index)"
                            v-b-popover.hover.left="aLang.c_detail"
                          >
                            <i class="fa fa-eye"></i>
                          </el-button>
                          <el-button
                            size="mini"
                            @click="fn_openModal_lichSuDiChuyen('update', scope.$index)"
                            v-b-popover.hover.left="aLang.c_update"
                          >
                            <i class="icon-pencil icons"></i>
                          </el-button>
                          <el-button
                            size="mini"
                            @click="fn_openModal_lichSuDiChuyen('delete',scope.$index)"
                            v-b-popover.hover.left="aLang.c_delete"
                          >
                            <i class="icon-trash icons"></i>
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </b-col>
                </b-row>
              </div>
            </b-tab>
          </b-tabs>

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
            >Thêm mới đối tượng</el-button>

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
            >{{aLang.c_update}} đối tượng</el-button>

            <el-button
              type="info"
              plain
              @click="fn_resetForm()"
              v-if="mData.viewMode == 'create'"
            >Xóa dữ liệu form</el-button>

            <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <!-- modal người liên quan -->
    <el-dialog
      :close-on-click-modal="false"
      title="Người liên quan"
      :visible.sync="mData.dialog.nguoiLienQuan.visible"
      width="70%"
      top="51px"
    >
      <div class="card-body scroll-y-80vh">
        <el-form
          :model="mData.dataFormOther"
          :rules="mData.validFormOther"
          ref="myForm_nguoiLienQuan"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="3">
              <el-form-item label="Loại đối tượng" prop="nguoi_lien_quan.type">
                <el-select
                  v-model="mData.dataFormOther.nguoi_lien_quan.type"
                  :placeholder="aLang.c_select"
                  filterable
                  clearable
                  :disabled="mData.dialog.nguoiLienQuan.viewMode == 'detail'"
                >
                  <el-option
                    v-for="item in mData.dataDefault.loaiDoiTuong"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Họ tên" prop="nguoi_lien_quan.ho_ten">
                <el-input
                  v-model="mData.dataFormOther.nguoi_lien_quan.ho_ten"
                  clearable
                  :disabled="mData.dialog.nguoiLienQuan.viewMode == 'detail'"
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Giới tính" prop="nguoi_lien_quan.gioi_tinh">
                <el-select
                  v-model="mData.dataFormOther.nguoi_lien_quan.gioi_tinh"
                  :placeholder="aLang.c_select"
                  filterable
                  clearable
                  :disabled="mData.dialog.nguoiLienQuan.viewMode == 'detail'"
                >
                  <el-option
                    v-for="item in mData.dataDefault.dmGioiTinh"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Ngày sinh" prop="nguoi_lien_quan.ngay_sinh">
                <el-date-picker
                  type="date"
                  :format="aElement.datepicker.formatDate"
                  :valueFormat="aElement.datepicker.valueFormat"
                  v-model="mData.dataFormOther.nguoi_lien_quan.ngay_sinh"
                  :placeholder="aElement.datepicker.placeholderDate"
                  clearable
                  :disabled="mData.dialog.nguoiLienQuan.viewMode == 'detail'"
                ></el-date-picker>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3">
              <el-form-item label="Số điện thoại" prop="nguoi_lien_quan.sodt_nguoi_tiep_xuc">
                <el-input
                  v-model="mData.dataFormOther.nguoi_lien_quan.sodt_nguoi_tiep_xuc"
                  clearable
                  :disabled="mData.dialog.nguoiLienQuan.viewMode == 'detail'"
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Số CMND" prop="nguoi_lien_quan.cmt_nguoi_tiep_xuc">
                <el-input
                  v-model="mData.dataFormOther.nguoi_lien_quan.cmt_nguoi_tiep_xuc"
                  clearable
                  :disabled="mData.dialog.nguoiLienQuan.viewMode == 'detail'"
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Hộ chiếu" prop="nguoi_lien_quan.ho_chieu">
                <el-input
                  v-model="mData.dataFormOther.nguoi_lien_quan.ho_chieu"
                  clearable
                  :disabled="mData.dialog.nguoiLienQuan.viewMode == 'detail'"
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Quốc tịch" prop="nguoi_lien_quan.ma_quoc_tich">
                <el-select
                  v-model="mData.dataFormOther.nguoi_lien_quan.ma_quoc_tich"
                  :placeholder="aLang.c_select"
                  filterable
                  clearable
                  :disabled="mData.dialog.nguoiLienQuan.viewMode == 'detail'"
                >
                  <el-option
                    v-for="item in mData.dataDefault.dmQuocGia"
                    :key="item.MA_QGIA"
                    :label="item.ten_qg"
                    :value="item.MA_QGIA"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3">
              <el-form-item label="Tỉnh/TP" prop="nguoi_lien_quan.ma_tinh">
                <el-select
                  v-model="mData.dataFormOther.nguoi_lien_quan.ma_tinh"
                  :placeholder="aLang.c_select"
                  filterable
                  clearable
                  :disabled="mData.dialog.nguoiLienQuan.viewMode == 'detail'"
                  @change="fn_changeTinh_lq(mData.dataFormOther.nguoi_lien_quan.ma_tinh, true)"
                >
                  <el-option
                    v-for="item in mData.dataDefault.dmTinh_lq"
                    :key="item.MA_TINH"
                    :label="item.TEN_TINH"
                    :value="item.MA_TINH"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Quận/Huyện" prop="nguoi_lien_quan.ma_huyen">
                <el-select
                  v-model="mData.dataFormOther.nguoi_lien_quan.ma_huyen"
                  :placeholder="aLang.c_select"
                  filterable
                  clearable
                  :disabled="mData.dialog.nguoiLienQuan.viewMode == 'detail'"
                  @change="fn_changeHuyen_lq(mData.dataFormOther.nguoi_lien_quan.ma_tinh, mData.dataFormOther.nguoi_lien_quan.ma_huyen, true)"
                >
                  <el-option
                    v-for="item in mData.dataDefault.dmHuyen_lq"
                    :key="item.MA_QUAN"
                    :label="item.TEN_QUAN"
                    :value="item.MA_QUAN"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Phường/Xã" prop="nguoi_lien_quan.ma_xa">
                <el-select
                  v-model="mData.dataFormOther.nguoi_lien_quan.ma_xa"
                  :placeholder="aLang.c_select"
                  filterable
                  clearable
                  :disabled="mData.dialog.nguoiLienQuan.viewMode == 'detail'"
                >
                  <el-option
                    v-for="item in mData.dataDefault.dmXa_lq"
                    :key="item.MA_XA"
                    :label="item.TEN_XA"
                    :value="item.MA_XA"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <el-form-item label="Địa chỉ" prop="nguoi_lien_quan.dia_chi_nguoi_tiep_xuc">
                <el-input
                  v-model="mData.dataFormOther.nguoi_lien_quan.dia_chi_nguoi_tiep_xuc"
                  clearable
                  :disabled="mData.dialog.nguoiLienQuan.viewMode == 'detail'"
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Nơi tiếp xúc" prop="nguoi_lien_quan.noi_tiep_xuc">
                <el-input
                  v-model="mData.dataFormOther.nguoi_lien_quan.noi_tiep_xuc"
                  clearable
                  :disabled="mData.dialog.nguoiLienQuan.viewMode == 'detail'"
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Thông tin khác" prop="nguoi_lien_quan.khac">
                <el-input
                  type="textarea"
                  rows="3"
                  v-model="mData.dataFormOther.nguoi_lien_quan.khac"
                  clearable
                  :disabled="mData.dialog.nguoiLienQuan.viewMode == 'detail'"
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12" class="text-center">
              <el-button
                type="info"
                plain
                v-ladda
                @click="fn_handle_nguoiLienQuan('create')"
                v-if="mData.dialog.nguoiLienQuan.viewMode == 'create'"
              >{{aLang.c_create}}</el-button>
              <el-button
                type="info"
                plain
                v-ladda
                @click="fn_handle_nguoiLienQuan('update')"
                v-if="mData.dialog.nguoiLienQuan.viewMode == 'update'"
              >{{aLang.c_update}}</el-button>
              <el-button
                @click="mData.dialog.nguoiLienQuan.visible = false"
                type="info"
                plain
              >{{aLang.c_close}}</el-button>
            </b-col>
          </b-row>
        </el-form>
      </div>
    </el-dialog>

    <!-- modal Lịch sử di chuyển -->
    <el-dialog
      :close-on-click-modal="false"
      title="Lịch sử di chuyển"
      :visible.sync="mData.dialog.lichSuDiChuyen.visible"
      width="70%"
      top="51px"
    >
      <div class="card-body scroll-y-80vh">
        <el-form
          :model="mData.dataFormOther"
          :rules="mData.validFormOther"
          ref="myForm_lichSuDiChuyen"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="4">
              <el-form-item
                label="Thời gian bắt đầu"
                prop="lich_su_di_chuyen.thoi_gian_tiep_xuc.bat_dau"
              >
                <el-date-picker
                  type="datetime"
                  :picker-options="mData.pickerOptions"
                  :format="aElement.datepicker.formatDatetime"
                  :valueFormat="aElement.datepicker.valueFormat"
                  v-model="mData.dataFormOther.lich_su_di_chuyen.thoi_gian_tiep_xuc.bat_dau"
                  :placeholder="aElement.datepicker.placeholderDatetime"
                  clearable
                  :disabled="mData.dialog.lichSuDiChuyen.viewMode == 'detail'"
                  @change="handleLich_su_di_chuyenTimeStart"
                ></el-date-picker>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item
                label="Thời gian kết thúc"
                prop="lich_su_di_chuyen.thoi_gian_tiep_xuc.ket_thuc"
              >
                <el-date-picker
                  type="datetime"
                  :picker-options="mData.pickerOptions"
                  :format="aElement.datepicker.formatDatetime"
                  :valueFormat="aElement.datepicker.valueFormat"
                  v-model="mData.dataFormOther.lich_su_di_chuyen.thoi_gian_tiep_xuc.ket_thuc"
                  :placeholder="aElement.datepicker.placeholderDatetime"
                  clearable
                  :disabled="mData.dialog.lichSuDiChuyen.viewMode == 'detail'"
                  @change="handleLich_su_di_chuyenTimeEnd"
                ></el-date-picker>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Họ tên người tiếp xúc" prop="lich_su_di_chuyen.ho_ten">
                <el-input
                  v-model="mData.dataFormOther.lich_su_di_chuyen.ho_ten"
                  clearable
                  :disabled="mData.dialog.lichSuDiChuyen.viewMode == 'detail'"
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3">
              <el-form-item label="Giới tính" prop="lich_su_di_chuyen.gioi_tinh">
                <el-select
                  v-model="mData.dataFormOther.lich_su_di_chuyen.gioi_tinh"
                  :placeholder="aLang.c_select"
                  filterable
                  clearable
                  :disabled="mData.dialog.lichSuDiChuyen.viewMode == 'detail'"
                >
                  <el-option
                    v-for="item in mData.dataDefault.dmGioiTinh"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Năm sinh" prop="lich_su_di_chuyen.nam_sinh">
                <el-input
                  v-model="mData.dataFormOther.lich_su_di_chuyen.nam_sinh"
                  clearable
                  :disabled="mData.dialog.lichSuDiChuyen.viewMode == 'detail'"
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Số điện thoại" prop="lich_su_di_chuyen.sodt_nguoi_tiep_xuc">
                <el-input
                  v-model="mData.dataFormOther.lich_su_di_chuyen.sodt_nguoi_tiep_xuc"
                  clearable
                  :disabled="mData.dialog.lichSuDiChuyen.viewMode == 'detail'"
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Số CMND" prop="lich_su_di_chuyen.cmt_nguoi_tiep_xuc">
                <el-input
                  v-model="mData.dataFormOther.lich_su_di_chuyen.cmt_nguoi_tiep_xuc"
                  clearable
                  :disabled="mData.dialog.lichSuDiChuyen.viewMode == 'detail'"
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <el-form-item label="Nơi tiếp xúc" prop="lich_su_di_chuyen.noi_tiep_xuc">
                <el-input
                  v-model="mData.dataFormOther.lich_su_di_chuyen.noi_tiep_xuc"
                  clearable
                  :disabled="mData.dialog.lichSuDiChuyen.viewMode == 'detail'"
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <el-form-item label="Nơi tiếp xúc" prop="lich_su_di_chuyen.khac">
                <el-input
                  type="textarea"
                  rows="4"
                  v-model="mData.dataFormOther.lich_su_di_chuyen.khac"
                  clearable
                  :disabled="mData.dialog.lichSuDiChuyen.viewMode == 'detail'"
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12" class="text-center">
              <el-button
                type="info"
                plain
                v-ladda
                @click="fn_handle_lichSuDiChuyen('create')"
                v-if="mData.dialog.lichSuDiChuyen.viewMode == 'create'"
              >{{aLang.c_create}}</el-button>
              <el-button
                type="info"
                plain
                v-ladda
                @click="fn_handle_lichSuDiChuyen('update')"
                v-if="mData.dialog.lichSuDiChuyen.viewMode == 'update'"
              >{{aLang.c_update}}</el-button>
              <el-button
                @click="mData.dialog.lichSuDiChuyen.visible = false"
                type="info"
                plain
              >{{aLang.c_close}}</el-button>
            </b-col>
          </b-row>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import DoiTuongTheoDoiModel from "./DoiTuongTheoDoiModel";
import DoiTuongTheoDoiApi from "../../../moduleApi/DoiTuongTheoDoiApi";
import Hssk831Api from "../../../moduleApi/Hssk831Api";
import DataService from "../../../service/DataService";
import KhaoSatApi from "../../../moduleApi/KhaoSatApi";
import ValidService from "../../../service/ValidService";
import HsskBn from "../HsskBN/HsskBNList";

export default {
  components: {
    HsskBn: HsskBn
  },
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "DoiTuongTheoDoi",
        pickerOptions: {
          disabledDate(time) {
            const start = new Date();
            let startTime = start.setTime(start.getTime() - 3600 * 1000);
            return time.getTime() >= startTime;
          }
        },
        dataDefault: {
          dmTinh: [],
          dmHuyen: [],
          dmXa: [],
          dmTinh_cscl: [],
          dmHuyen_cscl: [],
          dmXa_cscl: [],
          dmCoSo: [],
          dmTinh_lq: [],
          dmHuyen_lq: [],
          dmXa_lq: [],
          dmGioiTinh: DataService.gioiTinh,
          dmQuocGia: [],
          loaiDoiTuong: [
            {
              code: "BT",
              name: "BT"
            },
            {
              code: "F0",
              name: "F0"
            },
            {
              code: "F1",
              name: "F1"
            },
            {
              code: "F2",
              name: "F2"
            },
            {
              code: "F3",
              name: "F3"
            },
            {
              code: "F4",
              name: "F4"
            }
          ],
          loaiTiepXuc: [
            {
              id: 0,
              name: "Đi từ vùng dịch"
            },
            {
              id: 1,
              name: "Tiếp xúc với người bị bệnh"
            }
          ]
        },
        dataForm: MethodService.copyObject(DoiTuongTheoDoiModel.dataForm),
        validForm: DoiTuongTheoDoiModel.validForm,
        dataFormOther: MethodService.copyObject(
          DoiTuongTheoDoiModel.dataFormOther
        ),
        validFormOther: DoiTuongTheoDoiModel.validFormOther,
        search: {
          dataDefault: {
            isResultSearch: false
          },

          dataForm: {
            card_code: ""
          },
          validForm: {
            card_code: [ValidService.required]
          }
        },
        dialog: {
          nguoiLienQuan: {
            visible: false,
            viewMode: "create",
            indexModal: 0
          },
          lichSuDiChuyen: {
            visible: false,
            viewMode: "create",
            indexModal: 0
          }
        },
        tab: {
          index: [0, 0]
        }
      }
    };
  },
  methods: {
    async fn_searchUser() {
      this.$refs["myFormSearch"].validate(async valid => {
        if (valid) {
          try {
            let res = await Hssk831Api.getAllInForNguoiDan(
              this.mData.search.dataForm.card_code
            );
            if (res.result) {
              window.toastr.success("Tìm kiếm thành công");
              this.mData.search.dataDefault.isResultSearch = true;
              this.fn_changeData(res.result);
            } else {
              this.mData.search.dataDefault.hotenUser = null;
              window.toastr.error("Không tìm thấy người dân");
              this.mData.search.dataDefault.isResultSearch = false;
              this.fn_resetForm();
            }
          } catch (error) {
            this.mData.search.dataDefault.hotenUser = null;
            window.toastr.error("Không tìm thấy người dân");
            this.mData.search.dataDefault.isResultSearch = false;
            this.fn_resetForm();
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          let data = MethodService.copyObject(this.mData.dataForm);

          let dataNew = this.fn_changeData_doiTuong(data);
          if (type == "create") {
            if (this.$store.state.dataSearchUser.data.HSSK_Id) {
              // if (this.mData.dataForm.doi_tuong.id) {
              await DoiTuongTheoDoiApi.create(dataNew);
              this.fn_resetForm();
            } else {
              window.toastr.info("Bạn cần tìm kiếm và chọn 1 đối tượng trước");
              MethodService.stopLadda();
              return false;
            }
            // await DoiTuongTheoDoiApi.create(data);
            // this.fn_resetForm();
          }

          if (type == "update") {
            data.id = this.$router.currentRoute.params.id;
            await DoiTuongTheoDoiApi.update(data);
            this.fn_go(-1);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    fn_resetForm() {
      this.$refs["myForm"].resetFields();
      this.mData.dataForm = MethodService.copyObject(
        DoiTuongTheoDoiModel.dataForm
      );
      this.mData.dataFormOther = MethodService.copyObject(
        DoiTuongTheoDoiModel.dataFormOther
      );
    },

    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let res = await DoiTuongTheoDoiApi.list({ filters: ["id=" + id] });
      let data = MethodService.checkDifferentObject(
        DoiTuongTheoDoiModel.dataForm,
        res.result[0]
      );
      let dataNew = this.fn_changeData_doiTuong(data);
      this.mData.dataForm = dataNew;
    },

    fn_formatterDate(row, column, cellValue, ) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, ) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    async fn_changeTinh(MaTinhThanh, isReset) {
      if (isReset) {
        this.mData.dataForm.doi_tuong.ma_huyen = null;
        this.mData.dataForm.doi_tuong.ma_xa = null;
      }
      let res = await Hssk831Api.LoadDMQuanHuyen(MaTinhThanh);
      this.mData.dataDefault.dmHuyen = res.data;
    },

    async fn_changeHuyen(MaTinhThanh, MaQuanHuyen, isReset) {
      if (isReset) {
        this.mData.dataForm.doi_tuong.ma_xa = null;
      }
      let res = await Hssk831Api.LoadDMPhuongXa(MaTinhThanh, MaQuanHuyen);
      this.mData.dataDefault.dmXa = res.data;
    },

    async fn_changeTinh_lq(MaTinhThanh, isReset) {
      if (isReset) {
        this.mData.dataFormOther.nguoi_lien_quan.ma_huyen = null;
        this.mData.dataFormOther.nguoi_lien_quan.ma_xa = null;
      }
      let res = await Hssk831Api.LoadDMQuanHuyen(MaTinhThanh);
      this.mData.dataDefault.dmHuyen_lq = res.data;
    },

    async fn_changeHuyen_lq(MaTinhThanh, MaQuanHuyen, isReset) {
      if (isReset) {
        this.mData.dataFormOther.nguoi_lien_quan.ma_xa = null;
      }
      let res = await Hssk831Api.LoadDMPhuongXa(MaTinhThanh, MaQuanHuyen);
      this.mData.dataDefault.dmXa_lq = res.data;
    },

    async fn_changeTinh_cscl(MaTinhThanh, isReset) {
      if (isReset) {
        this.mData.dataForm.co_so_cach_ly.ma_huyen = null;
        this.mData.dataForm.co_so_cach_ly.ma_xa = null;
        this.mData.dataForm.co_so_cach_ly.ma_co_so = null;
      }
      let res = await Hssk831Api.LoadDMQuanHuyen(MaTinhThanh);
      this.mData.dataDefault.dmHuyen_cscl = res.data;

      let res_dm = await KhaoSatApi.LoadDMCoSoCachLy(MaTinhThanh);
      if (res_dm.data && res_dm.data.length > 0) {
        res_dm.data.map(item => {
          item.madiadiem = item.madiadiem.toString();
        });
      }

      this.mData.dataDefault.dmCoSo = res_dm.data;
    },

    async fn_changeHuyen_cscl(MaTinhThanh, MaQuanHuyen, isReset) {
      if (isReset) {
        this.mData.dataForm.co_so_cach_ly.ma_xa = null;
      }
      let res = await Hssk831Api.LoadDMPhuongXa(MaTinhThanh, MaQuanHuyen);
      this.mData.dataDefault.dmXa_cscl = res.data;
    },

    async fn_initDataDefault() {
      let res_LoadDMTinhThanh = await Hssk831Api.LoadDMTinhThanh();
      this.mData.dataDefault.dmTinh = this.mData.dataDefault.dmTinh_cscl = this.mData.dataDefault.dmTinh_lq = res_LoadDMTinhThanh.data
        ? res_LoadDMTinhThanh.data
        : [];

      let res_LoadDMQuocGia = await Hssk831Api.LoadDMQuocGia();
      this.mData.dataDefault.dmQuocGia = res_LoadDMQuocGia.data
        ? res_LoadDMQuocGia.data
        : [];
    },
    fn_openModalNguoiLienQuan(type, id) {
   
      if (type == "create") {
        this.mData.dialog.nguoiLienQuan.visible = true;
        this.mData.dialog.nguoiLienQuan.indexModal = undefined;
        this.mData.dialog.nguoiLienQuan.viewMode = type;
        this.mData.dataFormOther.nguoi_lien_quan = MethodService.copyObject(
          DoiTuongTheoDoiModel.dataFormOther.nguoi_lien_quan
        );
      }
      if (type == "update" || type == "detail") {
        this.mData.dialog.nguoiLienQuan.visible = true;
        this.mData.dialog.nguoiLienQuan.indexModal = id;
        this.mData.dialog.nguoiLienQuan.viewMode = type;
        let item = MethodService.copyObject(
          this.mData.dataForm.nguoi_lien_quan[id]
        );
        if (item.ma_tinh) {
          this.fn_changeTinh_lq(item.ma_tinh, false);
        }
        if (item.ma_tinh && item.ma_huyen) {
          this.fn_changeHuyen_lq(item.ma_tinh, item.ma_huyen, false);
        }
        this.mData.dataFormOther.nguoi_lien_quan = item;
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.mData.dataForm.nguoi_lien_quan.splice(id, 1);
          })
          .catch(() => {});
      }
    },

    fn_openModal_lichSuDiChuyen(type, id) {
      if (type == "create") {
        this.mData.dialog.lichSuDiChuyen.visible = true;
        this.mData.dialog.lichSuDiChuyen.indexModal = undefined;
        this.mData.dialog.lichSuDiChuyen.viewMode = type;
        this.mData.dataFormOther.lich_su_di_chuyen = MethodService.copyObject(
          DoiTuongTheoDoiModel.dataFormOther.lich_su_di_chuyen
        );
      }
      if (type == "update" || type == "detail") {
        this.mData.dialog.lichSuDiChuyen.visible = true;
        this.mData.dialog.lichSuDiChuyen.indexModal = id;
        this.mData.dialog.lichSuDiChuyen.viewMode = type;
        let item = MethodService.copyObject(
          this.mData.dataForm.lich_su_di_chuyen[id]
        );
        this.mData.dataFormOther.lich_su_di_chuyen = item;
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.mData.dataForm.lich_su_di_chuyen.splice(id, 1);
          })
          .catch(() => {});
      }
    },

    fn_changeHinhThucCachLy(type) {
      if (type == "O_NHA") {
        this.mData.dataForm.co_so_cach_ly.ma_tinh = null;
        this.mData.dataForm.co_so_cach_ly.ten_tinh = null;
        this.mData.dataForm.co_so_cach_ly.ma_huyen = null;
        this.mData.dataForm.co_so_cach_ly.ten_huyen = null;
        this.mData.dataForm.co_so_cach_ly.ma_xa = null;
        this.mData.dataForm.co_so_cach_ly.ten_xa = null;
        this.mData.dataForm.co_so_cach_ly.ma_co_so = null;
        this.mData.dataForm.co_so_cach_ly.ten_co_so = null;
        this.mData.dataForm.cb_theo_doi.ho_ten = null;
      }
      if (type == "CSCL") {
        this.mData.dataForm.co_so_cach_ly.dia_chi = null;
      }
    },

    fn_resetForm_nguoiLienQuan() {
      this.$refs["myForm_nguoiLienQuan"].resetFields();
    },

    fn_resetForm_lichSuDiChuyen() {
      this.$refs["myForm_lichSuDiChuyen"].resetFields();
    },

    fn_handle_nguoiLienQuan(type) {
         this.mData.dataFormOther.nguoi_lien_quan.ho_ten = MethodService.trimTextData(
        this.mData.dataFormOther.nguoi_lien_quan.ho_ten
      );
      if (type == "create") {
        this.$refs["myForm_nguoiLienQuan"].validate(async valid => {
          if (valid) {
            let item = MethodService.copyObject(
              this.mData.dataFormOther.nguoi_lien_quan
            );
            let newItem = this.fn_changeData_nguoiLienQuan(item);

            this.mData.dataForm.nguoi_lien_quan.push(newItem);
            this.mData.dialog.nguoiLienQuan.visible = false;
            this.fn_resetForm_nguoiLienQuan();
            MethodService.stopLadda();
          } else {
            MethodService.stopLadda();
            return false;
          }
        });
      }
      if (type == "update") {
        this.$refs["myForm_nguoiLienQuan"].validate(async valid => {
          if (valid) {
            let item = MethodService.copyObject(
              this.mData.dataFormOther.nguoi_lien_quan
            );

            this.mData.dataForm.nguoi_lien_quan.splice(
              this.mData.dialog.nguoiLienQuan.indexModal,
              1,
              item
            );

            this.fn_resetForm_nguoiLienQuan();
            this.mData.dialog.nguoiLienQuan.visible = false;
            MethodService.stopLadda();
          } else {
            MethodService.stopLadda();
            return false;
          }
        });
      }
    },

    fn_handle_lichSuDiChuyen(type) {
      this.mData.dataFormOther.lich_su_di_chuyen.ho_ten = MethodService.trimTextData(
        this.mData.dataFormOther.lich_su_di_chuyen.ho_ten
      );
      if (type == "create") {
        this.$refs["myForm_lichSuDiChuyen"].validate(async valid => {
          if (valid) {
            let item = MethodService.copyObject(
              this.mData.dataFormOther.lich_su_di_chuyen
            );
            // let newItem = this.fn_changeData_lichSuDiChuyen(item);

            this.mData.dataForm.lich_su_di_chuyen.push(item);
            this.mData.dialog.lichSuDiChuyen.visible = false;
            this.fn_resetForm_lichSuDiChuyen();
            MethodService.stopLadda();
          } else {
            MethodService.stopLadda();
            return false;
          }
        });
      }
      if (type == "update") {
        this.$refs["myForm_lichSuDiChuyen"].validate(async valid => {
          if (valid) {
            let item = MethodService.copyObject(
              this.mData.dataFormOther.lich_su_di_chuyen
            );

            this.mData.dataForm.lich_su_di_chuyen.splice(
              this.mData.dialog.lichSuDiChuyen.indexModal,
              1,
              item
            );

            this.fn_resetForm_lichSuDiChuyen();
            this.mData.dialog.lichSuDiChuyen.visible = false;
            MethodService.stopLadda();
          } else {
            MethodService.stopLadda();
            return false;
          }
        });
      }
    },

    fn_changeData_nguoiLienQuan(dataForm) {
      dataForm.quoc_tich = dataForm.ma_quoc_tich
        ? this.fn_mapName_quocTich(dataForm.ma_quoc_tich)
        : null;

      dataForm.ten_tinh = dataForm.ma_tinh
        ? this.fn_mapName_tinh(dataForm.ma_tinh)
        : null;

      dataForm.ten_huyen = dataForm.ma_huyen
        ? this.fn_mapName_huyen_lq(dataForm.ma_huyen)
        : null;

      dataForm.ten_xa = dataForm.ma_xa
        ? this.fn_mapName_xa_lq(dataForm.ma_xa)
        : null;
      return dataForm;
    },

    fn_changeData_doiTuong(dataForm) {
      if (dataForm.doi_tuong) {
        dataForm.doi_tuong.quoc_tich = dataForm.doi_tuong.ma_quoc_tich
          ? this.fn_mapName_quocTich(dataForm.doi_tuong.ma_quoc_tich)
          : null;

        dataForm.doi_tuong.ten_tinh = dataForm.doi_tuong.ma_tinh
          ? this.fn_mapName_tinh(dataForm.doi_tuong.ma_tinh)
          : null;

        dataForm.doi_tuong.ten_huyen = dataForm.doi_tuong.ma_huyen
          ? this.fn_mapName_huyen(dataForm.doi_tuong.ma_huyen)
          : null;

        dataForm.doi_tuong.ten_xa = dataForm.doi_tuong.ma_xa
          ? this.fn_mapName_xa(dataForm.doi_tuong.ma_xa)
          : null;
      }
      if (dataForm.thong_tin_chu_ho) {
        dataForm.thong_tin_chu_ho.quoc_tich = dataForm.thong_tin_chu_ho
          .ma_quoc_tich
          ? this.fn_mapName_quocTich(dataForm.thong_tin_chu_ho.ma_quoc_tich)
          : null;
      }

      if (dataForm.co_so_cach_ly && dataForm.loai_cach_ly == "CSCL") {
        dataForm.co_so_cach_ly.ten_tinh = dataForm.co_so_cach_ly.ma_tinh
          ? this.fn_mapName_tinh(dataForm.co_so_cach_ly.ma_tinh)
          : null;

        dataForm.co_so_cach_ly.ten_huyen = dataForm.co_so_cach_ly.ma_huyen
          ? this.fn_mapName_huyen_cscl(dataForm.co_so_cach_ly.ma_huyen)
          : null;

        dataForm.co_so_cach_ly.ten_xa = dataForm.co_so_cach_ly.ma_xa
          ? this.fn_mapName_xa_cscl(dataForm.co_so_cach_ly.ma_xa)
          : null;
      }

      return dataForm;
    },

    fn_mapName_quocTich(code) {
      let item = this.mData.dataDefault.dmQuocGia.find(item => {
        return item.MA_QGIA == code;
      });
      return item ? item.ten_qg : "";
    },

    fn_mapName_tinh(code) {
      let item = this.mData.dataDefault.dmTinh_lq.find(item => {
        return item.MA_TINH == code;
      });
      return item ? item.TEN_TINH : "";
    },

    fn_mapName_huyen(code) {
      let item = this.mData.dataDefault.dmHuyen.find(item => {
        return item.MA_QUAN == code;
      });
      return item ? item.TEN_QUAN : "";
    },

    fn_mapName_xa(code) {
      let item = this.mData.dataDefault.dmXa.find(item => {
        return item.MA_XA == code;
      });
      return item ? item.TEN_XA : "";
    },

    fn_mapName_huyen_lq(code) {
      let item = this.mData.dataDefault.dmHuyen_lq.find(item => {
        return item.MA_QUAN == code;
      });
      return item ? item.TEN_QUAN : "";
    },

    fn_mapName_xa_lq(code) {
      let item = this.mData.dataDefault.dmXa_lq.find(item => {
        return item.MA_XA == code;
      });
      return item ? item.TEN_XA : "";
    },

    fn_mapName_huyen_cscl(code) {
      let item = this.mData.dataDefault.dmHuyen_cscl.find(item => {
        return item.MA_QUAN == code;
      });
      return item ? item.TEN_QUAN : "";
    },

    fn_mapName_xa_cscl(code) {
      let item = this.mData.dataDefault.dmXa_cscl.find(item => {
        return item.MA_XA == code;
      });
      return item ? item.TEN_XA : "";
    },

    fn_mapName_coSo_cscl(code) {
      let item = this.mData.dataDefault.dmCoSo.find(item => {
        return item.madiadiem == code;
      });
      return item ? item.tendiadiem : "";
    },

    fn_mapName_gioiTinh(row, column, cellValue) {
      let item = this.mData.dataDefault.dmGioiTinh.find(item => {
        return item.id == cellValue;
      });
      if (item) {
        return item.text;
      } else {
        return "";
      }
    },
    fn_changeDataFormBySearchUser() {
      if (this.$store.state.dataSearchUser.isResult) {
        let dataNew = this.$store.state.dataSearchUser.data;
        // this.mData.dataForm.doi_tuong.id = dataNew.HSSK_Id
        //   ? dataNew.HSSK_Id
        //   : null;
        this.mData.dataForm.doi_tuong.card_code = dataNew.COS_MATHE
          ? dataNew.COS_MATHE
          : dataNew.COS_MATHE_DANGKY
          ? dataNew.COS_MATHE_DANGKY
          : null;
        this.mData.dataForm.doi_tuong.ten = dataNew.HO_TEN
          ? dataNew.HO_TEN
          : null;
        this.mData.dataForm.doi_tuong.ngay_sinh =
          dataNew.NAM_SINH +
          "-" +
          dataNew.THANG_SINH +
          "-" +
          dataNew.NGAY_SINH +
          "T00:00:00";
        this.mData.dataForm.doi_tuong.ma_tinh = dataNew.MA_TINH
          ? dataNew.MA_TINH
          : null;
        this.mData.dataForm.doi_tuong.ma_huyen = dataNew.MA_HUYEN
          ? dataNew.MA_HUYEN
          : null;
        this.mData.dataForm.doi_tuong.ma_xa = dataNew.MA_XA
          ? dataNew.MA_XA
          : null;
        this.mData.dataForm.doi_tuong.cmt = dataNew.CMND ? dataNew.CMND : null;
        this.mData.dataForm.doi_tuong.so_dien_thoai = dataNew.DIEN_THOAI
          ? dataNew.DIEN_THOAI
          : dataNew.DIEN_THOAI_DD;
        this.mData.dataForm.doi_tuong.dia_chi_luu_tru = dataNew.DIA_CHI_DKTT
          ? dataNew.DIA_CHI
          : null;
        this.mData.dataForm.doi_tuong.ma_quoc_tich = dataNew.MA_QGIA
          ? dataNew.MA_QGIA
          : null;

        if (dataNew.GIOI_TINH && dataNew.GIOI_TINH == 1) {
          this.mData.dataForm.doi_tuong.gioi_tinh = 2;
        } else if (dataNew.GIOI_TINH && dataNew.GIOI_TINH == 2) {
          this.mData.dataForm.doi_tuong.gioi_tinh = 1;
        } else {
          this.mData.dataForm.doi_tuong.gioi_tinh = dataNew.GIOI_TINH;
        }

        if (dataNew.MA_TINH) {
          this.fn_changeTinh(dataNew.MA_TINH, false);
        }
        if (dataNew.MA_TINH && dataNew.MA_HUYEN) {
          this.fn_changeHuyen(dataNew.MA_TINH, dataNew.MA_HUYEN, false);
        }
      } else {
        this.fn_resetForm();
      }
    },
    fn_test(data) {
      if (data) {
        let dataNew = this.$store.state.dataSearchUser.data;
        this.mData.dataForm.thong_tin_chu_ho.cmt = dataNew.CMND
          ? dataNew.CMND
          : null;
        this.mData.dataForm.thong_tin_chu_ho.so_dien_thoai = dataNew.DIEN_THOAI
          ? dataNew.DIEN_THOAI
          : dataNew.DIEN_THOAI_DD;
        this.mData.dataForm.thong_tin_chu_ho.card_code = dataNew.COS_MATHE
          ? dataNew.COS_MATHE
          : dataNew.COS_MATHE_DANGKY
          ? dataNew.COS_MATHE_DANGKY
          : null;
        this.mData.dataForm.thong_tin_chu_ho.ten = dataNew.HO_TEN
          ? dataNew.HO_TEN
          : null;
        this.mData.dataForm.thong_tin_chu_ho.ngay_sinh =
          dataNew.NAM_SINH +
          "-" +
          dataNew.THANG_SINH +
          "-" +
          dataNew.NGAY_SINH +
          "T00:00:00";
        this.mData.dataForm.thong_tin_chu_ho.ma_quoc_tich = dataNew.MA_QGIA
          ? dataNew.MA_QGIA
          : null;

        if (dataNew.GIOI_TINH && dataNew.GIOI_TINH == 1) {
          this.mData.dataForm.thong_tin_chu_ho.gioi_tinh = 2;
        } else if (dataNew.GIOI_TINH && dataNew.GIOI_TINH == 2) {
          this.mData.dataForm.thong_tin_chu_ho.gioi_tinh = 1;
        } else {
          this.mData.dataForm.thong_tin_chu_ho.gioi_tinh = dataNew.GIOI_TINH;
        }
      } else {
        this.mData.dataForm.thong_tin_chu_ho.card_code = null;
        this.mData.dataForm.thong_tin_chu_ho.ten = null;
        this.mData.dataForm.thong_tin_chu_ho.ngay_sinh = null;
        this.mData.dataForm.thong_tin_chu_ho.cmt = null;
        this.mData.dataForm.thong_tin_chu_ho.so_dien_thoai = null;
        this.mData.dataForm.thong_tin_chu_ho.gioi_tinh = null;
        this.mData.dataForm.thong_tin_chu_ho.ma_quoc_tich = null;
      }
    },
    handleLich_su_di_chuyenTimeStart(startDate) {
      let endDate = this.mData.dataFormOther.lich_su_di_chuyen
        .thoi_gian_tiep_xuc.ket_thuc;
      if (endDate && startDate) {
        let end = new Date(endDate);
        let endDateTime = end.getTime();
        let start = new Date(startDate);
        let startDateTime = start.getTime();
        if (endDateTime < startDateTime)
          return (this.mData.dataFormOther.lich_su_di_chuyen.thoi_gian_tiep_xuc.bat_dau = null);
      }
    },
    handleLich_su_di_chuyenTimeEnd(endDate) {
      let startDate = this.mData.dataFormOther.lich_su_di_chuyen
        .thoi_gian_tiep_xuc.bat_dau;
      if (endDate && startDate) {
        let start = new Date(startDate);
        let startDateTime = start.getTime();
        let end = new Date(endDate);
        let endDateTime = end.getTime();
        if (endDateTime < startDateTime)
          return (this.mData.dataFormOther.lich_su_di_chuyen.thoi_gian_tiep_xuc.ket_thuc = null);
      }
    },
    handleDoiTuong_chuyenTimeStart(startDate) {
      let endDate = this.mData.dataForm.ngay_ket_thuc_theo_doi;
      if (endDate && startDate) {
        let end = new Date(endDate);
        let endDateTime = end.getTime();
        let start = new Date(startDate);
        let startDateTime = start.getTime();
        if (endDateTime < startDateTime)
          return (this.mData.dataForm.ngay_theo_doi = null);
      }
    },
    handleDoiTuong_chuyenTimeEnd(endDate) {
      let startDate = this.mData.dataForm.ngay_theo_doi;
      if (endDate && startDate) {
        let start = new Date(startDate);
        let startDateTime = start.getTime();
        let end = new Date(endDate);
        let endDateTime = end.getTime();
        if (endDateTime < startDateTime)
          return (this.mData.dataForm.ngay_ket_thuc_theo_doi = null);
      }
    },
  },
  watch: {
    "$store.state.dataSearchUser.reload": function(newVal, oldVal) {
      var _this = this;
      _this.fn_changeDataFormBySearchUser();
    }
  },
  created: function() {
    this.fn_initDataDefault();
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function() {}
};
</script>